import { PageLayout } from "@/components/PageLayout";
import { PageHero, SectionCTA } from "@/components/PageHero";
import { Testimonials } from "@/components/Testimonials";

const Reviews = () => (
  <PageLayout testId="reviews-page">
    <PageHero
      eyebrow="Word On The Block"
      title="Real Talk"
      accent="Real Heat"
      breadcrumb="Reviews"
      subtitle="What Memphis is saying about HillBoyz. Wings, burgers, philly, and the banana pudding that built a following."
      bg="/assets/photos/IMG_9488.jpeg"
    />
    <Testimonials />
    <section className="bg-[#1A1A1A] border-t border-[#222] py-14">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h3 className="font-heading text-3xl sm:text-4xl text-white mb-6">
          Become A <span className="text-[#E60000]">Regular</span>
        </h3>
        <p className="text-white/70 mb-6">First order? Welcome to the family. Already a fan? Tag us @ilovehillboyz so we can shout you out.</p>
        <div className="flex flex-wrap justify-center gap-3">
          <SectionCTA to="/menu" label="Order Now" />
          <SectionCTA to="/visit" label="Visit Us" />
        </div>
      </div>
    </section>
  </PageLayout>
);

export default Reviews;
